import React from 'react';
import {fromJS, List, Map, Set} from 'immutable';

const CURSOR_DIRECTIONS = {
  NEXT: 'NEXT',
  PREVIOUS: 'PREVIOUS',
};

export const useCursorPagination = () => {
  const [currentPage, setCurrentPage] = React.useState(0);
  const [cursorForCurrentPage, setCursorForCurrentPage] = React.useState('');

  // Handles cursor pagination by keeping the state of the last current and next page query cursor values
  const [cursorTimeline, setCursorTimeline] = React.useState(List(['']))

  const goBackward = React.useCallback(() => {
    if (currentPage > 0) {
      const newCurrentCursor = cursorTimeline.get(currentPage - 1);

      setCursorForCurrentPage(newCurrentCursor);
      setCurrentPage(currentPage - 1);

      return newCurrentCursor;
    }
  }, [currentPage, cursorTimeline]);

  const goForward = React.useCallback(() => {
    if (currentPage < cursorTimeline.size) {
      const newCurrentCursor = cursorTimeline.get(currentPage + 1);

      setCursorForCurrentPage(newCurrentCursor);
      setCurrentPage(currentPage + 1);

      return newCurrentCursor;
    }
  }, [currentPage, cursorTimeline]);

  const addNextCursor = (cursorValue: string) => {
    setCursorTimeline(cursorTimeline.push(cursorValue));
  };

  const resetValues = () => {
    setCurrentPage(0);
    setCursorForCurrentPage('');
    setCursorTimeline(List(['']));
  };

  // TODO:Future Add listener to auto-reset cursor control

  return {
    goForward,
    goBackward,
    cursorForCurrentPage,
    currentPage,
    addNextCursor,
    resetValues,
    cursorTimeline,
  };
};



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/hooks/useCursorPagination.js